import * as R from 'ramda';
import axios from 'axios';

import {workflowsBy} from 'js/common/workflows';

const {campaignsDatatableUrl} = window.sn.urls;

export async function getCampaigns(page = 1, search) {
    const request = {
        pagination: {
            p: page - 1,
            pp: 12
        },
        order: {
            order_field: 'oldest_pending_content',
            direction: 'asc'
        },
        customConfiguration: {
            includePendingContentInfo: true,
            onlyWorkflows: R.keys(workflowsBy(R.prop('usesBrandContentApprovalQueue')))
        }
    };

    if (search) {
        request.search = search;
    }

    const response = await axios.post(campaignsDatatableUrl, request);
    return response.data;
}

export async function getCampaign(campaignSlug) {
    const response = await axios.get(`/brand/api/campaign/${campaignSlug}`);
    return response.data;
}

export async function getCampaignContentProgress(campaignSlug) {
    const response = await axios.get(`/brand/api/campaign/${campaignSlug}/content_progress`);
    return response.data;
}

export async function getCampaignContents(campaignSlug, queryParams) {
    const response = await axios.get(`/brand/api/campaign/${campaignSlug}/content`, {
        params: queryParams
    });
    return response.data;
}

export async function getCampaignContent(campaignSlug, contentMetadataId) {
    const response = await axios.get(
        `/brand/api/campaign/${campaignSlug}/content/${contentMetadataId}`
    );
    return response.data;
}

export async function getCampaignGuidelines(campaignSlug) {
    const response = await axios.get(`/brand/api/campaign/${campaignSlug}/guidelines`);
    return response.data;
}

export async function getOldestPendingContentForCampaign(campaignSlug, skipped = null) {
    const response = await axios.post(
        `/brand/api/campaign/${campaignSlug}/oldest_pending_content`,
        {skipped}
    );
    return response.data;
}

export async function approveContent(contentMetadataId, data) {
    const response = await axios.patch(
        `/brand/api/content/${contentMetadataId}`,
        R.merge(
            {
                status: 'approved',
                comment_source: 'brand_content_approval'
            },
            data
        )
    );
    return response.data;
}

export async function rejectContent(contentMetadataId, {missedGuidelines, comments}) {
    const response = await axios.patch(`/brand/api/content/${contentMetadataId}`, {
        status: 'rejected',
        missedGuidelines,
        comments,
        comment_source: 'brand_content_approval'
    });
    return response.data;
}

export async function getAllTags() {
    const response = await axios.get(`/brand/api/content_tags`);
    return response.data;
}

export async function createCreatorTag(name) {
    const response = await axios.post(`/brand/api/content_tags?name=${encodeURIComponent(name)}`);
    return response.data;
}

export async function deleteCreatorTag(id) {
    const response = await axios.delete(`/brand/api/content_tags/${id}`);
    return response.data;
}

export async function updateCreatorTag(name, id) {
    const response = await axios.put(`/brand/api/content_tags/${id}`, {
        name: name
    });
    return response.data;
}

export async function linkTagToContent(id, contentMetadataId) {
    const response = await axios.post(`/brand/api/content_tags/link`, {
        content_metadata_id: contentMetadataId,
        tag_id: id
    });
    return response.data;
}

export async function unlinkTagFromContent(id, contentMetadataId) {
    const response = await axios.delete(`/brand/api/content_tags/unlink`, {
        content_metadata_id: contentMetadataId,
        tag_id: id
    });
    return response.data;
}

export async function doNotDistributeContent(contentMetadataId, {reasons, feedback}) {
    const response = await axios.patch(`/brand/api/content/${contentMetadataId}`, {
        status: 'rejected',
        reasons,
        feedback,
        comment_source: 'brand_content_approval',
        do_not_distribute: true
    });
    return response.data;
}

export async function sendBrandContentFeedbackEmail({contentId, campaignSlug, emails, editRequest}) {
    const response = await axios.post('/brand/api/content/send', {
        contentId: contentId,
        emails: emails,
        feedback: editRequest,
        campaignSlug: campaignSlug
    });
    return response.data;
}

export async function getCampaignAnalyticsMetadata(campaignId) {
    const {data} = await axios.get(`/brands/renderer/analytics/${campaignId}`);
    return data;
}



// WEBPACK FOOTER //
// ./brand/brand_api_client.js